import { useRoute } from 'vue-router'
import { useHead, useSeoMeta } from '@unhead/vue'

import fornexOgLogo from '/@/assets/images/logos/og-logo-square.webp'

import type { RouteNamedMap } from '/@/router'
import { useI18n, type IntlMsgKey } from '/@/i18n'

const seoOGMap: Partial<
  Record<
    keyof RouteNamedMap,
    {
      title: IntlMsgKey
      description: IntlMsgKey
    }
  >
> = {
  HelpIndexPage: {
    title: 'help.title',
    description: 'help.description',
  },
  VhPage: {
    title: 'hosting.title',
    description: 'hosting.description',
  },
  VpsPage: {
    title: 'vps.title',
    description: 'vps.description',
  },
  DsPage: {
    title: 'dedicated.title',
    description: 'dedicated.description',
  },
  NewsPage: {
    title: 'seo.news.title',
    description: 'seo.news.description',
  },
  BackupPage: {
    title: 'backup.title',
    description: 'backup.description',
  },
  VpnPage: {
    title: 'vpn.title',
    description: 'vpn.description',
  },
  ServicesPage: {
    title: 'services.title',
    description: 'services.description',
  },
}

export function useOpenGraphCard() {
  const { t } = useI18n()
  const route = useRoute()

  const meta = seoOGMap[route.name]
  const ogImageUrl =
    (import.meta.env.DEV ? 'http://localhost:42012' : 'https://fornex.com') +
    fornexOgLogo

  const defaultTitle =
    t('home.promo.title') + ' ' + t('home.promo.title-highlight')

  const title =
    route.name === 'ContactsPage'
      ? 'Fornex Hosting'
      : meta?.title
        ? t(meta.title)
        : defaultTitle
  const description = t(
    meta?.description || 'home.services.hosting.description'
  )

  useSeoMeta({
    ogTitle: title,
    ogDescription: description,
    ogUrl: `https://fornex.com${route.fullPath}`,
    ogImage: ogImageUrl,
    ogType: 'website',
    ogSiteName: 'fornex.com',
    ogImageWidth: 1024,
    ogImageHeight: 1024,
    twitterTitle: title,
    twitterDescription: description,
    twitterCard: 'summary_large_image',
    twitterImage: ogImageUrl,
  })

  useHead({
    meta: [{ property: 'og:see_also', content: 'https://fornex.com/' }],
  })

  if (route.name === 'ContactsPage') {
    useHead({
      meta: [{ property: 'og:type', content: 'business.business' }],
    })
  }
}
